<app-journal-currencies-info-drawer>
  <main>
    <div class="flex flex-row justify-end items-center sub-header-container">
      <div class="sub-header-actions sub-header-actions-bar sub-header-actions-bar--status">
        <div class="sub-header-actions-bar__left status-header__meta">
          <span class="status-header__dot"></span>
          <span class="status-header__state">{{ "draft" | translate }}</span>
          <span class="status-header__bullet">•</span>
          <span class="status-header__date">{{
            form.value?.date | date: "MMM dd, yyyy"
          }}</span>
        </div>
        <kendo-buttongroup
          class="status-group status-group--primary"
          [disabled]="true"
        >
          <button
            kendoButton
            [toggleable]="true"
            [disabled]="true"
            class="status-button status-button--active"
          >
            {{ "draft" | translate }}
          </button>
          <button
            kendoButton
            [toggleable]="true"
            [disabled]="true"
            class="status-button status-button--inactive"
          >
            {{ "post" | translate }}
          </button>
        </kendo-buttongroup>
      </div>
    </div>

    <div class="content-container viewport-fill">
      @if (!isDrawerOpened) {
        <app-error-form
          [errorMessage]="errorMessage"
          [validationErrorMessages]="validationErrorMessages"
        ></app-error-form>
      }
      @if (isOnInitLoaded) {
        <div class="flex flex-col gap-6">
          <kendo-card>
            <div class="kendo-card-header">
              {{ "addJournalVouchers" | translate }}
            </div>
            <form [formGroup]="form" class="flex flex-col">
              <div class="flex flex-col gap-0 lg:flex-row lg:gap-6">
                <kendo-formfield class="flex-1">
                  <kendo-label text="{{ 'jvType' | translate }}">
                    <kendo-combobox
                      formControlName="jvType"
                      [data]="jvTypes"
                      [textField]="'label'"
                      [valueField]="'value'"
                      [valuePrimitive]="true"
                      [filterable]="true"
                      [allowCustom]="false"
                    >
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span class="font-medium">{{ dataItem.code }}</span> -
                        {{ dataItem.label }}
                      </ng-template>
                    </kendo-combobox>
                  </kendo-label>
                </kendo-formfield>
                <app-date-calendar
                  class="flex-1"
                  title="{{ 'date' | translate }}*"
                  [parentForm]="form"
                  [controlName]="'date'"
                  [min]="min"
                  [showValidation]="showValidation"
                >
                </app-date-calendar>
              </div>
              <div class="flex flex-col gap-0 lg:flex-row lg:gap-6">
                <kendo-formfield class="flex-1">
                  <kendo-label text="{{ 'reference' | translate }}">
                    <kendo-textbox
                      formControlName="reference"
                      maxlength="20"
                      (keydown.space)="$event.preventDefault()"
                    ></kendo-textbox>
                  </kendo-label>
                  @if (
                    form.controls.reference.errors?.pattern && showValidation
                  ) {
                    <kendo-formerror>{{
                      "onlyAlphanumericCharactersHypensAndUnderscoresAreAllowed"
                        | translate
                    }}</kendo-formerror>
                  }
                </kendo-formfield>
                <div class="flex-1"></div>
              </div>
              <div class="flex flex-col gap-0 lg:flex-row lg:gap-6">
                <kendo-formfield class="basis-[50%]">
                  <kendo-label text="{{ 'note' | translate }}*">
                    <kendo-textbox
                      #note
                      formControlName="note"
                      maxlength="100"
                    ></kendo-textbox>
                  </kendo-label>
                  @if (form.controls.note.errors?.required && showValidation) {
                    <kendo-formerror>{{
                      "noteIsRequired" | translate
                    }}</kendo-formerror>
                  }
                </kendo-formfield>
                <div class="basis-[50%]">
                  @if (isCompanyProjectLinked) {
                    <app-company-project-dropdown
                      [parentForm]="form"
                      controlName="projectUid"
                      (loadData)="projectsData = $event"
                    ></app-company-project-dropdown>
                  }
                </div>
              </div>
            </form>
          </kendo-card>
          <kendo-card class="journal-entries-card">
            <div class="journal-entries-header">
              {{ "journalEntries" | translate }}
            </div>
            <!-- <button
              type="button"
              class="journal-entries-add-row"
              [disabled]="true"
            >
              <span class="journal-entries-add-row__icon">+</span>
              <span class="journal-entries-add-row__text">{{
                "addJournalEntry" | translate
              }}</span>
            </button> -->
            <app-journal-editable-grid
              #JournalEditableGrid
              [mode]="'edit'"
              [data]="gridData"
              [defaultRemark]="note.value"
              [documentDate]="form.value.date"
              [projectsData]="projectsData"
              [projectUid]="form.value.projectUid"
              (checkDirty)="dirtyFormHandler($event)"
            ></app-journal-editable-grid>
          </kendo-card>
        </div>
      }
    </div>

    <!-- ZEY-1966: Save is a POST /Journals (Create verb); Post is that create followed by
         PATCH /Journals/Status.
         ZEY-2053: both halves are the Create verb now — posting stopped being a grant of its own,
         so anyone offered Save is offered Post with it. -->
    @if (permissionStore.journalPermissions$ | async; as journalPerms) {
      <app-action-bar
        [isBoxShadow]="false"
        [isWaiting]="isWaiting"
        [screenType]="'Form'"
        [actionsOptions]="[
          {
            visible: journalPerms.canCreate,
            class: 'btn-primary',
            label: 'Save and Close',
            labelName: ('saveAndClose' | translate),
            options: [{ text: ('saveAndNew' | translate), value: 'Save and New' }]
          },
          {
            visible: true,
            class: 'btn-outline-secondary',
            label: 'Discard',
            labelName: ('discard' | translate)
          }
        ]"
        [recordsOptions]="[
          {
            visible: journalPerms.canCreate,
            class: 'btn-outline-primary',
            label: 'Post',
            labelName: ('post' | translate)
          }
        ]"
        (buttonClick)="onActionClick($event, 'add')"
      >
      </app-action-bar>
    }
  </main>
</app-journal-currencies-info-drawer>
